export default "__VITE_ASSET__9910c63c__"